import React, { useEffect } from 'react'
import SubFooter from '../components/Footer/SubFooter'

function ProfileScreen() {
  useEffect(() => {
    document.title = 'Profile | Stephenson Adventures';
  },[]);

  return (
    <div className="standard-ountline">
        <div className="standard-area">ProfileScreen</div>
        <SubFooter />   
     </div>
  )
}

export default ProfileScreen